import {
    PriceDetailsCashbackDto,
    PriceDetailsCashbackType,
    PriceDetailsDiscountDto
} from "../components/custom/models/PriceDetailsPopinDto";
import {PromotionType} from "../components/ob1/models/Price";

export function hasMultipleNonPermanentDurations(durations: ReadonlyArray<number>): boolean {
    const nonPermanentDurations = new Set(durations.filter((duration) => duration > 0));
    return nonPermanentDurations.size > 1;
}

export function computeDiscountType(discounts: ReadonlyArray<PriceDetailsDiscountDto>): PromotionType | undefined {
    if (discounts.length === 0) {
        return undefined;
    }
    if (hasMultipleNonPermanentDurations(discounts.map((discount) => discount.duration))) {
        return PromotionType.END_OF_PROMO;
    } else if (discounts.some((discount) => discount.duration > 0)) {
        return PromotionType.PROMO_DURATION;
    }
    return undefined;
}

export function computeFinalDiscountType(
    discounts: ReadonlyArray<PriceDetailsDiscountDto>,
    cashbacks: ReadonlyArray<PriceDetailsCashbackDto>
): PromotionType | undefined {
    const hasDifferentDiscountAndCashbackDurations = computeHasDifferentDiscountAndCashbackDurations(discounts, cashbacks);
    if (hasDifferentDiscountAndCashbackDurations) {
        return PromotionType.END_OF_PROMO;
    }
    const discountType = computeDiscountType(discounts);
    if (discountType) {
        return discountType;
    }
    if (cashbacks.some((cashback) => cashback.duration > 0)) {
        return PromotionType.PROMO_DURATION;
    }
    return undefined;
}

function computeHasDifferentDiscountAndCashbackDurations(
    discounts: ReadonlyArray<PriceDetailsDiscountDto>,
    cashbacks: ReadonlyArray<PriceDetailsCashbackDto>
): boolean {
    if (cashbacks.length > 0 && discounts.length > 0) {
        const allDurations = [...discounts, ...cashbacks].map((item) => item.duration);
        return hasMultipleNonPermanentDurations(allDurations);
    } else if (discounts.length > 0) {
        return hasMultipleNonPermanentDurations(discounts.map((discount) => discount.duration));
    } else if (cashbacks.length > 0) {
        return hasMultipleNonPermanentDurations(cashbacks.map((cashback) => cashback.duration));
    }
    return false;
}

export function computeCashbackType(cashbacks: ReadonlyArray<PriceDetailsCashbackDto>): PriceDetailsCashbackType | undefined {
    const hasCheatCode = cashbacks.some((cashback) => cashback.cashbackType === PriceDetailsCashbackType.CHEAT_CODE);
    const hasSaferPhone = cashbacks.some((cashback) => cashback.cashbackType === PriceDetailsCashbackType.SAFER_PHONE);
    const hasOther = cashbacks.some((cashback) => cashback.cashbackType === PriceDetailsCashbackType.OTHER);

    if (hasCheatCode && hasSaferPhone) {
        return PriceDetailsCashbackType.OTHER;
    } else if (hasCheatCode) {
        return PriceDetailsCashbackType.CHEAT_CODE;
    } else if (hasSaferPhone) {
        return PriceDetailsCashbackType.SAFER_PHONE;
    } else if (hasOther) {
        return PriceDetailsCashbackType.OTHER;
    }
    return undefined;
}
